module.exports = __webpack_public_path__ + "media/newstyle/images/icon-ebook-orange-c13f1bc59ddbb4aa909bb41d5d0631f2.svg";